module.exports = __webpack_public_path__ + "packs/media/bundles/Admin/AdminDoc-3a64d5a4a387cd3b5e1d141535081212.md";